import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background text-primary-foreground">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="flex flex-col items-center"
      >
        <p className="text-xl font-heading text-primary mb-4">Loading Webfiny...</p>
        <div className="w-32 h-1 bg-primary/30 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-primary"
            initial={{ x: "-100%" }}
            animate={{ x: "0%" }}
            transition={{ duration: 1.8, ease: "easeInOut", repeat: Infinity, repeatType: "loop" }}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;